'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface ChatMessageProps extends React.HTMLAttributes<HTMLDivElement> {
  message: string;
  isUser?: boolean;
  timestamp?: string;
  avatar?: React.ReactNode;
}

export const ChatMessage = React.forwardRef<HTMLDivElement, ChatMessageProps>(
  ({ className, message, isUser = false, timestamp, avatar, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={SubframeUtils.twClassNames(
          'flex w-full min-w-0 gap-3',
          isUser ? 'flex-row-reverse' : 'flex-row',
          className,
        )}
        {...props}
      >
        {!isUser && avatar && <div className="flex-shrink-0">{avatar}</div>}

        <div
          className={SubframeUtils.twClassNames(
            'flex max-w-[85%] min-w-0 flex-col gap-1 rounded-2xl p-4 text-sm shadow-sm',
            isUser
              ? 'bg-brand-600 rounded-tr-none text-white'
              : 'rounded-tl-none border border-neutral-100 bg-white text-neutral-900',
          )}
        >
          <div className="leading-relaxed break-words whitespace-pre-wrap">{message}</div>
          {timestamp && (
            <span
              className={SubframeUtils.twClassNames(
                'mt-1 text-[10px]',
                isUser ? 'text-brand-100' : 'text-neutral-400',
              )}
            >
              {timestamp}
            </span>
          )}
        </div>
      </div>
    );
  },
);
